import React from "react"
import PropTypes from "prop-types"

import styles from "./navitem-action.module.css"

export const NavItemAction = ({
  children,
  propagateEvent = false,
  ...props
}) => {
  // filtering out style and className
  /* eslint-disable-next-line react/prop-types */
  const { style, className, ...rest } = props

  const handleClick = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <div
      {...rest}
      className={styles.NavItemAction}
      onClick={propagateEvent ? null : handleClick}
    >
      {children}
    </div>
  )
}

NavItemAction.displayName = "NavItemAction"

NavItemAction.propTypes = {
  /**
   * React node to render action elements for a nav item.
   */
  children: PropTypes.node,
  /**
   * Allow events to propagate to the parent element.
   */
  propagateEvent: PropTypes.bool,
}

NavItemAction.defaultProps = {
  propagateEvent: false,
}
